<template>
  <div style="height: 80px; width: 100%;"></div>
  <div class="banner">
    <img src="@/images/produban.png" alt="" />
  </div>
  <div class="title">
    <h1>整体解决方案</h1>
    <div class="heng"></div>
  </div>

  <div class="description">
    我们提供仓储场地规划、软件系统管控、仓储硬件集成、自动化硬件开发、第三方仓配服务、快递合作对接、仓储管理人员培养等整体解决方案。
  </div>
  
  <div class="responsive-image">
    <img src="@/images/98bf4efdc9492acf90b42e28f972ff0d.jpg" alt="" />
  </div>
  
  <div class="responsive-image-container">
    <img src="@/images/1752568046008.png" alt="" />
  </div>

  <div class="title">
    <h1>服务流程</h1>
    <div class="heng"></div>
  </div>

  <div class="responsive-image-container">
    <img src="@/images/1752568221514.png" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.banner img {
  width: 100%;
  height: auto;
}

.heng {
  background-color: rgb(0, 0, 0);
  width: 50px;
  height: 6px;
  border-radius: 10px;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px 0;
}

.description {
  font-size: 16px;
  line-height: 28px;
  color: #666;
  width: 90%;
  max-width: 800px;
  margin: 15px auto;
  text-align: center;
}

.responsive-image-container {
  width: 100%;
  text-align: center;
  margin: 20px 0;
}
.responsive-image img {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.responsive-image {
  width: 60%;
  text-align: center;
  margin: 0 auto;
}

.responsive-image-container img {
  max-width: 100%;
  height: auto;
  display: inline-block;
}


@media (max-width: 768px) {
  .description {
    width: 95%;
    font-size: 15px;
  }

  .responsive-image-container img {
    width: 100%;
    height: auto;
  }
}
</style>